export default $ => {

  const modules = [
    require('./membership-form'),
    require('./membership-purchase-form'),
    require('./team-create'),
    require('./team-join'),
    require('./upload-image'),
    require('./subscription-membership-form'),
  ];

  // boot each module
  modules.forEach(function (module) {
    module.default($);
  })
}



// WEBPACK FOOTER //
// ./assets/js/scripts/main.js